<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
     
    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card  (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
               Müstahzarlar
              </ng-container>
              <ng-container mCardBody>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Adı</th>
                        
                       
                          <th>Etiket</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let label of mustahzarlar">
                        
                          <td>{{label.tanim}} </td>
                        
                          
                          <td>
                        <span *ngIf="label.hasLabel; else yok" class="success">Var</span><ng-template #yok> <span class="danger">Yok </span></ng-template>  
                            
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td>
                            <button class="btn btn-default" (click)="prev()"><<</button>
                            <button class="btn">{{page}}</button>
                            <button class="btn btn-default" (click)="next()">>></button>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
               
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
